import React from 'react';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import { getConfig } from './src/config';
/**
 * base url for all end points
 */

export const getBaseUrl = () => {
  if (typeof window === 'undefined') return '';
  return getConfig().hiringmotionBaseUrl;
};

export const getCareerCaptchaKey = () => getConfig().careerCaptchaKey;
export const getAuthClientId = () => getConfig().googleClientId;

export const FILE_UPLOAD = '/website/file-upload-url';

export const ERROR_MESSAGE = 'Oops! Something went wrong please try again later.';

export const RATING = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const RATING_TYPE = [
  { label: FavoriteBorderIcon, value: <FavoriteBorderIcon />, name: 'HEART' },
  { label: StarOutlineIcon, value: <StarOutlineIcon />, name: 'STAR' },
  { label: ThumbUpAltIcon, value: <ThumbUpAltIcon />, name: 'THUMBS UP' },
];

export const ACCEPT_TYPES =
  'application/pdf, image/*, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export const TEXT_VALIDATIONS = [
  'CONTAINS',
  'DOES NOT CONTAIN',
  'MATCHES',
  'DOES NOT MATCH',
  'EMAIL',
  'URL',
];

export const LENGTH_VALIDATION = ['MINIMUM CHARACTERS', 'MAXIMUM CHARACTERS'];

export const fileTypes = {
  pdf: 'application/pdf',
  doc: 'application/x-ole-storage',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};
